import { Box, Stack, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import {
  DELETE_COLUMN_WIDTH_PX,
  ICON_COLUMN_WIDTH_PX,
  NUMBER_COLUMN_WIDTH_PX,
  TYPE_COLUMN_WIDTH_PX,
} from './VariableSourceRow';

// Column labels for VariableSourceList's rows -- widths and spacing mirror
// VariableSourceRow exactly so each label sits above its column.
export const VariableSourceListHeader = () => {
  const { formatMessage } = useIntl();

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={3}
      data-testid="analysis-variable-list-header"
      sx={{ px: 4, py: 2, bgcolor: 'background.card' }}
    >
      <Box sx={{ width: ICON_COLUMN_WIDTH_PX, flexShrink: 0 }} />
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ width: NUMBER_COLUMN_WIDTH_PX, flexShrink: 0 }}
      >
        {formatMessage({ id: 'analysisDetail.tables.preview.variableList.column.number' })}
      </Typography>
      <Typography variant="overline" color="text.secondary" sx={{ flexGrow: 1, minWidth: 0 }}>
        {formatMessage({ id: 'analysisDetail.tables.preview.variableList.column.variable' })}
      </Typography>
      <Typography variant="overline" color="text.secondary" noWrap>
        {formatMessage({ id: 'analysisDetail.tables.preview.variableList.column.usedIn' })}
      </Typography>
      <Typography
        variant="overline"
        color="text.secondary"
        noWrap
        sx={{ width: TYPE_COLUMN_WIDTH_PX, flexShrink: 0, textAlign: 'right' }}
      >
        {formatMessage({ id: 'analysisDetail.tables.preview.variableList.column.format' })}
      </Typography>
      <Box sx={{ width: DELETE_COLUMN_WIDTH_PX, flexShrink: 0 }} />
    </Stack>
  );
};
